import { useState } from "react";
import { Upload } from "lucide-react";
import { Button, Card, CardBody, CardHeader, Textarea } from "@/components/ui";

export function DatasetImport({ loading, onImport, onCancel }: { loading: boolean; onImport: (json: string) => void; onCancel: () => void }) {
  const [json, setJson] = useState("");

  return (
    <Card>
      <CardHeader
        icon={<Upload className="h-5 w-5" />}
        title="Vragenlijst importeren uit JSON"
        description="Plak de JSON van de vragenlijst hieronder. Alle verplichte velden moeten aanwezig zijn: version, name, description, questions, enz."
      />
      <CardBody className="space-y-4">
        <Textarea
          id="import-json"
          aria-label="JSON van de vragenlijst"
          value={json}
          onChange={(e) => setJson(e.target.value)}
          className="h-96 font-mono text-[13px]"
          spellCheck={false}
          placeholder={'{\n  "version": "6.0",\n  "name": "Mijn vragenlijst",\n  ...\n}'}
        />
        <div className="flex gap-2">
          <Button onClick={() => onImport(json)} loading={loading}>
            {loading ? "Importeren…" : "Vragenlijst importeren"}
          </Button>
          <Button variant="outline" onClick={onCancel}>
            Annuleren
          </Button>
        </div>
      </CardBody>
    </Card>
  );
}
